"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Security = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_lottie_1 = __importDefault(require("react-lottie"));
const react_i18next_1 = require("react-i18next");
const de_ui_1 = require("@delab-team/de-ui");
const securitySticker = __importStar(require("../../../assets/stickers/security.json"));
const svg_selector_1 = require("../../../assets/svg-selector");
const security_module_css_1 = __importDefault(require("./security.module.css"));
const Security = ({ isCheckedPrivacy, setIsCheckedPrivacy }) => {
    const approveOptions = {
        loop: true,
        autoplay: true,
        animationData: securitySticker,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
    };
    const TgObj = sdk_1.default;
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleCheckboxClick = (index) => {
        const updatedCheckedState = [...isCheckedPrivacy];
        updatedCheckedState[index] = !updatedCheckedState[index];
        setIsCheckedPrivacy(updatedCheckedState);
        TgObj.HapticFeedback.impactOccurred('medium');
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: security_module_css_1.default.inner, children: [(0, jsx_runtime_1.jsx)("div", { className: security_module_css_1.default.innerImg, children: (0, jsx_runtime_1.jsx)(react_lottie_1.default, { options: approveOptions, height: 180, isClickToPauseDisabled: true, width: 180 }) }), (0, jsx_runtime_1.jsx)(de_ui_1.Title, { variant: "h2", className: security_module_css_1.default.innerTitle, children: t('security.title') }), (0, jsx_runtime_1.jsx)("ul", { className: security_module_css_1.default.innerList, children: isCheckedPrivacy.map((checked, index) => ((0, jsx_runtime_1.jsxs)("li", { className: security_module_css_1.default.innerItem, children: [(0, jsx_runtime_1.jsx)("div", { className: `${security_module_css_1.default.checkbox} ${checked ? security_module_css_1.default.checkboxChecked : ''}`, onClick: () => handleCheckboxClick(index), children: checked && (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "checked-2" }) }), (0, jsx_runtime_1.jsx)("p", { onClick: () => handleCheckboxClick(index), children: t(`security.item-${index + 1}`) })] }, index))) })] }));
};
exports.Security = Security;
